/*
 * 接口统一集成模块
 */
import * as code from "./modules/code";
import * as user from "./modules/user";
import * as chat from "./modules/chat";
import * as seat from "./modules/seat";

// 默认全部导出
export default {
  code,
  user,
  chat,
  seat,
};
